module.exports = __webpack_public_path__ + "static/media/videoCamera.579b2730.svg";